import React from "react";
import NotificationsManager from "@/components/page/schedulePush/NotificationsManager";
import { HashRouter as Router, Route, Routes } from "react-router";
import SchedulePushNotificationContext from "@/context/SchedulePushNotificationContext";

const SchedulePush = ({contentIsArchived = false}: {contentIsArchived?: boolean}) => {
  return (
    <Router>
      <SchedulePushNotificationContext>
      <Routes>
        <Route path="/" element={<NotificationsManager contentIsArchived={contentIsArchived}/>} />
      </Routes>
      </SchedulePushNotificationContext>
    </Router>
  );
};

export default SchedulePush;
